import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppSettings, DEFAULT_APP_SETTINGS } from '../../shared/models';
import { StorageService } from './storage.service';

/**
 * Réglages applicatifs locaux (device-only, jamais envoyés au backend). État
 * partagé via BehaviorSubject, persistance déléguée à StorageService (IndexedDB).
 */
@Injectable({ providedIn: 'root' })
export class SettingsService {
  private settingsSubject = new BehaviorSubject<AppSettings>({ ...DEFAULT_APP_SETTINGS });
  settings$ = this.settingsSubject.asObservable();

  constructor(private storage: StorageService) {}

  /** Charge les réglages persistés (appelé au démarrage via APP_INITIALIZER). */
  async load(): Promise<void> {
    const stored = await this.storage.getSettings();
    this.settingsSubject.next({ ...DEFAULT_APP_SETTINGS, ...(stored ?? {}) });
  }

  get current(): AppSettings {
    return this.settingsSubject.value;
  }

  /** Met à jour un sous-ensemble de réglages et persiste. */
  async update(patch: Partial<AppSettings>): Promise<void> {
    const next = { ...this.settingsSubject.value, ...patch };
    this.settingsSubject.next(next);
    await this.storage.saveSettings(next);
  }
}
